import { MessageBox } from 'element-ui'

if (!!window.ActiveXObject || 'ActiveXObject' in window) {
  MessageBox({
    title: '温馨提示',
    message:
      '自2015年3月起，微软已宣布弃用IE，且不再对IE提供任何更新维护，请' +
      '<a target="_blank" style="color:blue" href="https://www.google.cn/intl/zh-CN/chrome/">点击此处</a>,下载谷歌浏览器',
    type: 'warning',
    showClose: false,
    showConfirmButton: false,
    closeOnClickModal: false,
    closeOnPressEscape: false,
    closeOnHashChange: false,
    dangerouslyUseHTMLString: true
  }).then(() => {})
}
